import {  ITerceirizacaoRepository } from "../../repositories/terceirizacao_repository";
import { ICreateDocumentoUseCase } from "../../../presentation/useCases/create/create_documento_use_case";
import { ICreateFuncionarioTreinamentoUseCase } from "../../../presentation/useCases/create/create_funcionario_treinamento_use_case";


export class CreateFuncionarioTreinamentoUseCase implements ICreateFuncionarioTreinamentoUseCase {
  constructor(
    private readonly repository: ITerceirizacaoRepository,
  ) { }

  async createFuncionarioTreinamento(
    idFuncionario: number,
    idTreinamento: number,
    cargaHoraria: number,
    local: string,
    instrutor: string,
    dataRealização: Date,
    prazoAvaliacao: number,
  ): Promise<void> {
    await this.repository.createFuncionarioTreinamento(
      idFuncionario,
      idTreinamento,
      cargaHoraria,
      dataRealização,
      instrutor,
      local,
      prazoAvaliacao,
    );
  }
}